import { ReactElement } from 'react'
import { IconFa } from '../icon-fa'

export function IconSearch(): ReactElement {
  return <IconFa icon={['far', 'search']} />
}
